(function () {
  if (!window.customElements || customElements.get('launch-countdown')) return;

  var SECOND = 1000;
  var MINUTE = 60 * SECOND;
  var HOUR = 60 * MINUTE;
  var DAY = 24 * HOUR;

  function pad(value) {
    return value < 10 ? '0' + value : String(value);
  }

  class LaunchCountdown extends HTMLElement {
    connectedCallback() {
      this.start = Date.parse(this.getAttribute('data-start'));
      this.launch = Date.parse(this.getAttribute('data-launch'));
      this.hideBeforeStart = this.getAttribute('data-hide-before-start') === 'true';

      // The theme editor always shows the clock, so edits stay visible whatever
      // the schedule says.
      this.alwaysShow = !!(window.Shopify && window.Shopify.designMode);

      this.clock = this.querySelector('[data-countdown-clock]');
      this.message = this.querySelector('[data-countdown-message]');
      this.heading = this.querySelector('[data-countdown-heading]');
      this.summary = this.querySelector('[data-countdown-summary]');
      this.fields = {
        days: this.querySelector('[data-countdown-days]'),
        hours: this.querySelector('[data-countdown-hours]'),
        minutes: this.querySelector('[data-countdown-minutes]'),
        seconds: this.querySelector('[data-countdown-seconds]')
      };

      // An unreadable date would otherwise leave a clock frozen at zero.
      if (isNaN(this.launch)) {
        this.render('ended');
        return;
      }

      this.lastSummary = '';
      this.tick();
      this.timer = window.setInterval(this.tick.bind(this), SECOND);
    }

    disconnectedCallback() {
      window.clearInterval(this.timer);
    }

    tick() {
      var now = Date.now();
      var remaining = this.launch - now;

      if (remaining <= 0) {
        window.clearInterval(this.timer);
        this.render('ended');
        return;
      }

      if (!isNaN(this.start) && now < this.start && this.hideBeforeStart && !this.alwaysShow) {
        this.render('waiting');
        return;
      }

      this.render('running', remaining);
    }

    render(state, remaining) {
      this.setAttribute('data-state', state);

      if (state === 'ended') {
        if (this.clock) this.clock.hidden = true;
        if (this.heading) this.heading.hidden = true;
        if (this.message) this.message.hidden = false;
        if (this.summary && this.message) {
          this.summary.textContent = this.message.textContent.trim();
        }
        return;
      }

      if (this.message) this.message.hidden = true;
      if (this.heading) this.heading.hidden = false;

      if (state === 'waiting') {
        if (this.clock) this.clock.hidden = true;
        if (this.summary) this.summary.textContent = '';
        return;
      }

      if (this.clock) this.clock.hidden = false;

      var days = Math.floor(remaining / DAY);
      var hours = Math.floor((remaining % DAY) / HOUR);
      var minutes = Math.floor((remaining % HOUR) / MINUTE);
      var seconds = Math.floor((remaining % MINUTE) / SECOND);

      this.write('days', days);
      this.write('hours', hours);
      this.write('minutes', minutes);
      this.write('seconds', seconds);

      // Rewritten once a minute rather than every tick, so assistive tech is
      // not handed a new string every second.
      if (this.summary && seconds === 0) {
        var text = days + ' days, ' + hours + ' hours and ' + minutes + ' minutes remaining';
        if (text !== this.lastSummary) {
          this.summary.textContent = text;
          this.lastSummary = text;
        }
      }
    }

    write(key, value) {
      var field = this.fields[key];
      if (!field) return;

      var text = pad(value);
      if (field.textContent !== text) field.textContent = text;
    }
  }

  customElements.define('launch-countdown', LaunchCountdown);
})();
